"use strict";

var app = require('app');

module.exports = function (options) {
  app.decodeAndApplyConfig(options.init);
};